<template>
  <div class="float-window-container">
    <div class="item" @click="handleJumpPage('OPEN_ABOUTUS_CONTACTUS')">
      <div class="item-img sy"></div>
      <div class="item-title">产品试用</div>
    </div>
    <div class="item" @click="mailToYouto('mailto:youtu@tencent.com?subject=商务合作')">
      <div class="item-img swlx"></div>
      <div class="item-title">商务合作</div>
    </div>
    <!-- <div class="item">
      <img class="item-img" src="./img/floatwindow/icon-smgz.png"/>
      <div class="item-title">扫码关注</div>
    </div> -->
  </div>
</template>

<script>
import RouteKey from '@/common/RouteKey';

export default {
  name: 'FloatWindow',
  methods: {
    handleJumpPage(url, key) {
      if (url.indexOf('http') !== -1) {
        window.open(url, '_blank');
        return;
      }
      url = RouteKey[url];
      if (key != null) {
        this.$router.transfer(url, {key: key});
        return;
      }
      this.$router.transfer(url);
    },
    mailToYouto(url) {
      window.location.href = url;
    }
  }
};
</script>

<style lang="less" scoped>
.float-window-container {
  overflow: hidden;
  z-index: 9999;
  position: fixed;
  text-align:center;
  right: 10px;
  top: 50%;
  .item {
    box-sizing: border-box;;
    width: 70px;
    height: 70px;
    background: #FFFFFF;
    border: 1px solid rgba(245,247,250,1);
    padding: 10px 10px;
    .item-img {
      width: 30px;
      height: 30px;
      margin: 0 auto;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
      &.sy {
        background-image: url('./img/floatwindow/icon_sy_w.png');
      }
      &.swlx {
        background-image: url('./img/floatwindow/icon_swlx_w.png');
      }
    }
    .item-title {
      font-size: 12px;
      a {
        text-decoration: none;
        color: #3D485D;
      }
    }
    &:hover {
      cursor: pointer;
    }
  }
  > div:nth-child(-n+2) {
    border-bottom: none;
  }
}
@media screen and (-Webkit-min-device-pixel-ratio: 2),
    screen and (-moz-min-device-pixel-ratio: 2),
    screen and (-o-min-device-pixel-ratio: 2),
    screen and (min-device-pixel-ratio: 2) {
  .float-window-container {
    .item {
      .item-img {
        &.sy {
          background-image: url('./img/floatwindow/icon_sy_w_2x.png');
        }
        &.swlx {
          background-image: url('./img/floatwindow/icon_swlx_w_2x.png');
        }
      }
    }
  }
}
@media screen and (min-width:1600px){
  .float-window-container {
    .item {
      .item-img {
        &.sy {
          background-image: url('./img/floatwindow/icon_sy_w_2x.png');
        }
        &.swlx {
          background-image: url('./img/floatwindow/icon_swlx_w_2x.png');
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/open/common/FloatWindow.vue